window.form_helpers = function()
{
    var self = this;

    /**
     * Get the axios file headers, set the content type to 'multipart/form-data'
     *
     * @author Rick van der Burg <rick@click.nl>
     * @return json
     */
    self.axiosFileHeaders = function() 
    {
        return {
            headers: { 
                'Content-Type': 'multipart/form-data'
            }
        };
    };

    /**
     * Build the form data based on the given json
     *
     * @author Rick van der Burg <rick@click.nl>
     * @param  form_data
     * @param  data
     * @param  parent_key
     * @return void
     */
    self.buildFormData = function(form_data, data, parent_key) 
    {
        // check if data isset, is  an object, not a date or not a file
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
            // loop through all keys of the data
            Object.keys(data).forEach(key => {
                // Build the form data based on the key and parent key
                self.buildFormData(form_data, data[key], parent_key ? `${parent_key}[${key}]` : key);
            });
        } else {
            // set the value to the parent key
            const value = data == null ? '' : data;
            form_data.append(parent_key, value);
        }
    };

    /**
     * Initialize form data
     *
     * @author Rick van der Burg <rick@click.nl>
     * @return FormData
     */
    self.jsonToFormData = function(data)
    {
        const form_data = new FormData();
        self.buildFormData(form_data, data);
        return form_data;
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/frontend/components/axios-helpers.js